export enum ActionType {
	CAMERA_FETCH_INFO = 'CAMERA_FETCH_INFO',
	COMMANDS_FETCH_INFO = 'COMMANDS_FETCH_INFO',
	MULTIMEDIA_OPEN_BY_DATE = 'MULTIMEDIA_OPEN_BY_DATE',
	MULTIMEDIA_OPEN_BY_TRACKING_HISTORY_ID = 'MULTIMEDIA_OPEN_BY_TRACKING_HISTORY_ID',
	MULTIMEDIA_CLOSE_MODAL = 'MULTIMEDIA_CLOSE_MODAL',
	MULTIMEDIA_UPDATE_UTC_DATE = 'MULTIMEDIA_UPDATE_UTC_DATE',
	MULTIMEDIA_CLEAR_REFHESH_DATA = 'MULTIMEDIA_CLEAR_REFHESH_DATA',
	MULTIMEDIA_CLEAR_CHANNEL_KEY = 'MULTIMEDIA_CLEAR_CHANNEL_KEY',
	MULTIMEDIA_REQUEST_LOADING = 'MULTIMEDIA_REQUEST_LOADING',
	UPDATE_DEVICE_EVENT = 'UPDATE_DEVICE_EVENT',
	GROUPS_FETCH_INFO = 'GROUPS_FETCH_INFO',
	GROUPS_ADD = 'GROUPS_ADD',
	GROUPS_EDIT = 'GROUPS_EDIT',
	GROUPS_DELETE = 'GROUPS_DELETE',
	GROUPS_FETCH_DEVICES = 'GROUPS_FETCH_DEVICES',
	GROUPS_FETCH_ACCOUNTS = 'GROUPS_FETCH_ACCOUNTS',
	GROUPS_UN_SHARE = 'GROUPS_UN_SHARE',
	LOADING_TRACE = 'LOADING_TRACE',
	GOOGLE_LOADED = 'GOOGLE_LOADED',
	CLEAN_REDUCER = 'CLEAN_REDUCER',
	LOG_OUT = 'LOG_OUT',
	USER_UPDATE_PROFILE = 'USER_UPDATE_PROFILE',
	TWO_FACTOR_AUTH_STATUS = 'TWO_FACTOR_AUTH_STATUS',
	UPDATE_DEVICE = 'UPDATE_DEVICE',
	MAP_DEVICES_SET_DEVICES = 'MAP_DEVICES_SET_DEVICES',
	MAP_DEVICES_UPDATE_DEVICE = 'MAP_DEVICES_UPDATE_DEVICE',
	MAP_DEVICES_UPDATE_LAST_REPORT = 'MAP_DEVICES_UPDATE_LAST_REPORT',
	MAP_DEVICES_CLEAR_DEVICES = 'MAP_DEVICES_CLEAR_DEVICES',
	MAP_DEVICES_SET_SELECTED_GROUPS = 'MAP_DEVICES_SET_SELECTED_GROUPS',
	MAP_DEVICES_SET_SELECTED_UNIT = 'MAP_DEVICES_SET_SELECTED_UNIT',
	MAP_DEVICES_SET_SELECTED_GROUP_CHILD = 'MAP_DEVICES_SET_SELECTED_GROUP_CHILD',
	MAP_DEVICES_REMOVE_SELECTED_GROUP = 'MAP_DEVICES_REMOVE_SELECTED_GROUP',
	MAP_DEVICES_REMOVE_SELECTED_GROUP_CHILD = 'MAP_DEVICES_REMOVE_SELECTED_GROUP_CHILD',
	MAP_DEVICES_CLEAR_ALL_DATA = 'MAP_DEVICES_CLEAR_DEVICES_ALL_DATA',
	MAP_DEVICES_SET_LOADING_STATUS = 'MAP_DEVICES_SET_LOADING_STATUS',
	MAP_DEVICES_SET_LOADING_SEGMENTED_TRAIL = 'MAP_DEVICES_SET_LOADING_SEGMENTED_TRAIL',
	MAP_DEVICES_SET_LAST_EVENTS = 'MAP_DEVICES_SET_LAST_EVENTS',
	MAP_DEVICES_SET_SELECTED_DATE = 'MAP_DEVICES_SET_SELECTED_DATE',
	MAP_DEVICES_UPDATE_TRAIL_DATA = 'MAP_DEVICES_UPDATE_TRAIL_DATA',
	MAP_DEVICES_UPDATE_HISTORICAL_MARKER = 'MAP_DEVICES_UPDATE_HISTORICAL_MARKER',
	MAP_DEVICES_UPDATE_DEVICE_PROPERTIES = 'MAP_DEVICES_UPDATE_DEVICE_PROPERTIES',
	COMPANY_FETCH_ROLES = 'COMPANY_FETCH_ROLES',
	GEOFENCE_EDITOR_SET_IS_PANEL_ACTIVE = 'GEOFENCE_EDITOR_SET_IS_PANEL_ACTIVE',
	GEOFENCE_EDITOR_SET_SELECTED_FEATURES = 'GEOFENCE_EDITOR_SET_SELECTED_FEATURES',
	GEOFENCE_EDITOR_SET_FEATURE = 'GEOFENCE_EDITOR_SET_FEATURE',
	GEOFENCE_EDITOR_SET_COLOR = 'GEOFENCE_EDITOR_SET_COLOR',
	GEOFENCE_EDITOR_UPDATE = 'GEOFENCE_EDITOR_UPDATE',
	GEOFENCE_EDITOR_CLEAR = 'GEOFENCE_EDITOR_CLEAR',
	GEOFENCE_EDITOR_RESET = 'GEOFENCE_EDITOR_RESET',
	GEOFENCE_PANEL_SET_CURRENT_MODE = 'GEOFENCE_PANEL_SET_CURRENT_MODE',
	GEOFENCE_PANEL_SET_BEHAVIOR_TO_EDIT = 'GEOFENCE_PANEL_SET_BEHAVIOR_TO_EDIT',
	GEOFENCE_PANEL_SET_LOADING = 'GEOFENCE_PANEL_SET_LOADING',
	GEOFENCE_SET_GEOFENCES = 'GEOFENCE_SET_GEOFENCES',
	GEOFENCE_UPDATE_GEOFENCE = 'GEOFENCE_UPDATE_GEOFENCE',
	GEOFENCE_UPDATE_BEHAVIOR = 'GEOFENCE_UPDATE_BEHAVIOR',
	GEOFENCE_ADD_BEHAVIOR = 'GEOFENCE_ADD_BEHAVIOR',
	GEOFENCE_PANEL_DELETE_GEOFENCES = 'GEOFENCE_PANEL_DELETE_GEOFENCES',
	GEOFENCE_PANEL_DELETE_GEOFENCE_BEHAVIORS = 'GEOFENCE_PANEL_DELETE_GEOFENCE_BEHAVIORS',
	BANNER_SET_CONFIGURATION = 'BANNER_SET_CONFIGURATION',
	SESSION_UPDATE_INFORMATION = 'SESSION_UPDATE_INFORMATION',
	SESSION_UPDATE_IS_PAST_DUE = 'SESSION_UPDATE_IS_PAST_DUE',
	GEOFENCE_SET_SELECTED_ID = 'GEOFENCE_SET_SELECTED_ID',
	GEOFENCE_CLEAR_SELECTED_ID = 'GEOFENCE_CLEAR_SELECTED_ID',
}

export interface IAction<T = undefined> {
	type: ActionType;
	payload?: T;
}

export interface CleanReducerAction extends IAction<undefined> {
	type: ActionType.CLEAN_REDUCER;
}
export interface LogOutAction extends IAction<undefined> {
	type: ActionType.LOG_OUT;
}
